// extracted by mini-css-extract-plugin
export default {"body":"modal_body__SQUnU","overlay":"modal_overlay__D1Rh8","modal":"modal_modal__XhTq8","centered":"modal_centered__HNjkt"};